export class Cookies{
	init(){		
		$(document).ready(function () {

			if (($.cookie("cookie_agree")) == 1){
				$('.cookies-tab').hide();      
			}else {
				$('.cookies-tab').fadeIn(500);      
			}

			$('.cookies-tab .button').click(function () {
				cookieAgree();
				return false;
			});
		});

		function cookieAgree(){
			$.cookie("cookie_agree", 1, { expires : 365, path: '/' });
			$('.cookies-tab').fadeOut(400);
		}
	}
}